import { render } from "./TeamComponent.vue?vue&type=template&id=01837805"
import script from "./TeamComponent.vue?vue&type=script&lang=js"
export * from "./TeamComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__